import { Component,OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TwoFactorService } from '../../../services/twofactor.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-login-key',
  templateUrl: './login-key.component.html',
  styleUrls: ['../login.component.css'],
  imports: [CommonModule],
  standalone: true
})
export class LoginKeyComponent implements OnInit {
  errorMessage: any = "";
  verificationCode: any = "";
  qrCodeUrl: any = "";
  isMobile = false;
  userEmail: any = "";

  constructor(
    private twoFactorService: TwoFactorService,
    private router: Router,
  ) { }


  ngOnInit(): void {
    console.log("Test")
  }

  backToChooser(): any {
    this.router.navigate(['login'], {queryParams: { mode: '2fa' }});
  }

  confirmCode(): any {
    const code = $('#2fa_confirm').val();
    this.verificationCode = code;

    this.twoFactorService.verifyCode(this.userEmail, this.verificationCode).then(r => {
      console.log("Code confirmed", r);
      if (r == 1)
        this.router.navigate(['dashboard']);
      else {
        this.errorMessage = "The 2FA Code is incorrect.  Please try again.";
      }
    })
  }
}
